import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import { useStyles } from './yes-no.styles';
import { YesNoProps } from './yes-no.models';
import { ExternalLinks } from '../../../../../constants';
import { Page } from '../../page/page';
import { images } from './yes-no.items';

export const YesNo = ({ eyeKey, isYes }: YesNoProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const imgSrc = isMobile ? images[eyeKey as keyof typeof images][0] : images[eyeKey as keyof typeof images][1];
  const link = ExternalLinks[eyeKey as keyof typeof ExternalLinks];
  const title = isYes ? `${eyeKey}.title.yes` : `${eyeKey}.title.no`;

  return (
    <Page title={intl.formatMessage({ id: title })} description={intl.formatMessage({ id: 'eyeKey.description' })}>
      <a
        className={classes.root}
        data-testid="eyeKey-content"
        aria-label={intl.formatMessage({ id: `${eyeKey}.ariaLabel` })}
        href={link}
      >
        <img src={imgSrc} width={422} height={792} alt="" />
      </a>
    </Page>
  );
};
